import admin from '../middleware/admin';
import auth from '../middleware/auth';
import requiresPasswordChange from "../middleware/user-password-change";

export default {
    path: 'uznemumi/:companyId',
    name: 'view-company',
    meta: {
        middleware: [auth, admin, requiresPasswordChange],
    },
    component: () => import('@/views/site/Company'),
}